<template>
  <div class="home">

    <div class="container" v-if="data">

      <section class="section-header">

        <img src="img/dna-logo.svg" width=100 height=100 alt="DNA" class="logo">

        <div class="valign-wrapper">
          <h1>DNA Netti taloyhtiöille</h1>
        </div>

        <div class="row clear">
          <div class="col m6">
            <strong>{{ data.custom.eventName }}</strong><br>
            <!-- Lorem ipsum -->
          </div>
          <div class="col m6 right-align">
            <strong>{{ data.custom.hostName }}</strong><br>
            <!-- Lorem ipsum<br> -->
            {{ currentDate }}
          </div>
        </div>

      </section>

      <section class="section-internet">
        <h2>DNA Netti taloyhtiöille</h2>

        <div class="row">

          <div class="col s12 m6 checkbox-col" v-for="(offer, index) in data.custom.internet" :key="index">
            <Checkbox :offer="offer" v-on:toggleActive="selectInternet(offer)" :isActive="offer === selections.internet" />
          </div>  

        </div>

      </section>

      <section class="section-extras">
        <h2>Netin lisäpalvelut</h2>

        <div class="row">
          <div class="col s12 m6 checkbox-col" v-for="(offer, index) in data.custom.extras" :key="index">
            <Checkbox :offer="offer" v-on:toggleActive="selectExtras(offer)" :isActive="selections.extras.indexOf(offer) !== -1" />
          </div>  
        </div>

      </section>

      <section class="section-packages">
        <h2>Kanavapaketit</h2>

        <div class="info bg-aquablue color-white center-align">
          DNA Netti -asiakkaalle -20 % C More ja C More Total -kanavapaketeista
        </div>

        <div class="info bg-melonyellow center-align">
          Uusille DNA TV Hubi + Netti -asiakkaille Viasat Kulta tutustumistarjous 2 kk 0 €.
        </div>

        <div class="row">
          <div class="col s12 m6">

            <div class="colored-border border-hotpink">
              <h3>DNA SportMix</h3>

              <div class="checkbox-col">
                <Checkbox :offer="data.custom.channels.sportmix" v-on:toggleActive="selectSportmix(data.custom.channels.sportmix)" :isActive="data.custom.channels.sportmix === selections.sportmix"/>
              </div>  

              <h3>+ valitse lisäksi:</h3>

              <div class="checkbox-col" v-for="(offer, index) in data.custom.channels.sportmixPlus" :key="index + '-sportmix'">
                <Checkbox :offer="offer" v-on:toggleActive="selectSportmixPlus(offer)" :isActive="selections.sportmixPlus.indexOf(offer) !== -1" />
              </div>  
            </div>

            <div class="colored-border border-aquablue checkbox-aquablue">
              <h3>C More</h3>
              <div class="checkbox-col" v-for="(offer, index) in data.custom.channels.cmore" :key="index + '-cmore'">
                <Checkbox :offer="offer" v-on:toggleActive="selectCMore(offer)" :isActive="selections.cmore.indexOf(offer) !== -1" />
              </div>  
            </div>

          </div>
          <div class="col s12 m6">
            <div class="colored-border border-melonyellow checkbox-melonyellow">
              <h3>Viasat</h3>

              <div class="checkbox-col" v-for="(offer, index) in data.custom.channels.viasat" :key="index + '-viasat'">
                <Checkbox :offer="offer" v-on:toggleActive="selectViasat(offer)" :isActive="selections.viasat.indexOf(offer) !== -1" />
              </div>  
            </div>
            <div class="colored-border border-black checkbox-black">
              <h3>DNA Mix -kanavapaketit</h3>

              <div class="checkbox-col" v-for="(offer, index) in data.custom.channels.dnaMix" :key="index + '-dnamix'">
                <Checkbox :offer="offer" v-on:toggleActive="selectDNAMix(offer)" :isActive="selections.dnaMix.indexOf(offer) !== -1" />
              </div>  
            </div>

          </div>
        </div>


      </section>

      <section class="section-customerinfo">
        <h2>Asiakkaan tiedot</h2>

          <div class="row">
            <form class="col s12">
              <div class="row">
                <div class="dna-input-field col s6">
                  <label for="firstName">Etunimi</label>
                  <input placeholder="Tilaajan etunimi" id="firstName" type="text" class="validate" v-model="customer.firstName">
                </div>
                <div class="dna-input-field col s6">
                  <label for="lastName">Sukunimi</label>
                  <input placeholder="Tilaajan sukunimi" id="lastName" type="text" class="validate" v-model="customer.lastName">
                </div>
              </div>
              <div class="row">
                <div class="dna-input-field col s6">
                  <label for="socialSecurityNum">Henkilöturvatunnus</label>
                  <input placeholder="Esim. 000000-000X" id="socialSecurityNum" type="text" class="validate" v-model="customer.socialSecurityNum">
                </div>
                <div class="dna-input-field col s6">
                  <label for="phone">Puhelinnumero</label>
                  <input placeholder="Syötä puhelinnumero" id="phone" type="text" class="validate" v-model="customer.phone">
                </div>
              </div>
              <div class="row">
                <div class="dna-input-field col s12">
                  <label for="email">Email</label>
                  <input id="email" type="email" class="validate" placeholder="Sähköpostiosoite" v-model="customer.email">
                  <!-- <span class="helper-text" data-error="wrong" data-success="right">Helper text</span> -->
                </div>
              </div>
              <div class="row">
                <div class="dna-input-field col s12">
                  <label for="address">Katuosoite</label>
                  <input id="address" type="text" class="validate" placeholder="Katuosoite" v-model="customer.address">
                  <!-- <span class="helper-text" data-error="wrong" data-success="right">Helper text</span> -->
                </div>
              </div>
              <div class="row">
                <div class="dna-input-field col s6">
                  <label for="zipCode">Postinumero</label>
                  <input placeholder="Postinumero" id="zipCode" type="text" class="validate" v-model="customer.zipCode">
                </div>
                <div class="dna-input-field col s6">
                  <label for="city">Postitoimipaikka</label>
                  <input placeholder="Postitoimipaikka" id="city" type="text" class="validate" v-model="customer.city">
                </div>
              </div>
            </form>
          </div>

      </section>

      <section class="section-moreinfo">
        <h2>Lisätietoja</h2>

        <textarea class="materialize-textarea" placeholder="Tilaukseen liittyvät mahdolliset lisätiedot" name="" id="" cols="30" rows="3"></textarea>

      </section>
    </div>

    <section class="section-summary">

      <div class="container">
        <div class="row">
          <div class="col s6">
            <h2>Tilaustiedot</h2>

            <h3>Asiakas</h3>

            <ul>
              <li>{{ customer.firstName }} {{ customer.lastName }}</li>
              <li>{{ customer.socialSecurityNum }}</li>
              <li>{{ customer.phone }}</li>
              <li>{{ customer.email }}</li>
              <li>{{ customer.address }}</li>
              <li>{{ customer.zipCode }} {{ customer.city }} </li>
            </ul>
          </div>

          <div class="col s6">
            <h3>Ostoskori</h3>
            <ul class="cart">
              <li v-for="(product, index) in cart" :key="index" :class="{ summary: product.summary  }">
                <div class="price-line" :class="{ 'has-discount': product.discount }">
                  <span class="float-right">{{ product.price | formatPrice }} €/kk</span>
                  {{product.heading}} 
                </div>
                
                <div v-if="product.discount" class="discount">
                  <div class="discount-line color-hotpink">
                    <span class="float-right">{{ product.discount }} %</span>
                    {{ product.discountText }}
                  </div>
                  <span class="float-right">{{ product.discountPrice | formatPrice }} €/kk</span>
                  <br>
                </div>
              </li>
            </ul>
            
          </div>

        </div>

        <button class="btn btn-submit btn-full" @click="checkForm()">Lähetä tilaus</button>
      </div>
    </section>


  </div>
</template>

<script>
import axios from 'axios'
import Checkbox from './Checkbox'
// import data from '../assets/dummydata/data.js'

export default {
  name: 'Home',
  components: {
    Checkbox
  },
  data() {
    return {
      data: null,
      selections: {
        internet: null,
        extras: [],
        channels: null,
        sportmix: null,
        sportmixPlus: [],
        cmore: [],
        viasat: [],
        dnaMix: []
      },
      selectionExtras: [],
      customer: {
        firstName: null,
        lastName: null,
        address: null,
        zipCode: null,
        city: null,
        phone: null,
        email: null,
        extraInformation: null,
        socialSecurityNum: null
      },
      errors: {
        firstName: null,
        lastName: null,
        address: null,
        zipCode: null,
        city: null,
        phone: null,
        email: null,
        extraInformation: null,
        socialSecurityNum: null
      },
      currentDate: null
    }
  },
  created() {
    this.currentDate = (new Date()).toLocaleDateString().replace(/\//g,'.');
    this.getFormData(this.data)
  },
  mounted() {

  },
  computed: {
    cart() {
      let cart = []
      if (this.selections.internet) {
        cart.push(this.selections.internet)
      }
      if (this.selections.extras.length > 0) {
        this.selections.extras.map(e => {
          cart.push(e)
        })
      }
      if (this.selections.sportmix) {
        cart.push(this.selections.sportmix)
      }
      ['sportmixPlus', 'cmore', 'viasat', 'dnaMix'].map(pkg => {
        if (this.selections[pkg].length > 0) {
          this.selections[pkg].map(e => {
            if (pkg === 'cmore') {
              e.discount = -20;
              e.discountText = 'DNA Netti asiakas'
              e.discountPrice = (100 + e.discount) / 100 * e.price 
            }
            cart.push(e)
          })
        }
      })

      let total = 0;
      cart.map(item => { total += item.discountPrice ? item.discountPrice : item.price })
      cart.push({
        heading: 'Yhteensä',
        summary: true,
        price: total
      })
      return cart
    }
  },
  methods: {
    getFormData(data) {
      // console.log('getData')
      let apiBase = 'https://kampanja3.dna.fi/salainen-mesta-xyz/tlk-lomake/form.json'
      // let apiBase = 'http://dev.dna.fi:3000'
      // this.data.x = 1
      // console.log(this.data)
      // axios.get(apiBase + '/form')
      axios.get(apiBase)
      .then((response) => {
        // console.log(response.data.data)
        this.data = response.data.data
        // console.log(_this)
        // _this.data.data = response.data
      })
      .catch((error) => {
        console.error(error)
      })
    },
    selectInternet(offer) {
      console.log('selectInternet')
      this.selections.internet = this.selections.internet === offer ? null : offer
    },
    selectSportmix(offer) {
      console.log('selectSportmix')
      console.log(offer)
      console.log(this.selections)
      if (this.selections.sportmix === offer) {
        this.selections.sportmix = null
        this.selections.sportmixPlus = []
      } else {
        this.selections.sportmix = offer
      }
    },
    selectSingle(offer, selection) {
      console.log('selectSingle')
      console.log(offer)
      console.log(selection)
      selection = selection === offer ? null : offer
    },
    selectExtras(offer) {
      console.log('selectExtras')
      // this.selectionExtras.push(offer)
      if (this.selections.extras.indexOf(offer) === -1) {
        this.$set(this.selections.extras, this.selections.extras.length, offer)
      } else {
        this.selections.extras = this.selections.extras.filter(e => e !== offer)
      }

    },
    selectSportmixPlus(offer) {
      console.log('selectSportmixPlus')
      // this.selectionExtras.push(offer)
      if (this.selections.sportmixPlus.indexOf(offer) === -1) {
        // this.$set(this.selections.sportmixPlus, this.selections.sportmixPlus.length, offer)
        this.selections.sportmixPlus.push(offer)
        this.selections.sportmix = this.data.custom.channels.sportmix
      } else {
        this.selections.sportmixPlus = this.selections.sportmixPlus.filter(e => e !== offer)
      }

    },
    selectCMore(offer) {
      console.log('selectCMore')
      if (this.selections.cmore.indexOf(offer) === -1) {
        this.selections.cmore.push(offer)
      } else {
        this.selections.cmore = this.selections.cmore.filter(e => e !== offer)
      }
    },
    selectViasat(offer) {
      console.log('selectViasat')
      if (this.selections.viasat.indexOf(offer) === -1) {
        this.selections.viasat.push(offer)
      } else {
        this.selections.viasat = this.selections.viasat.filter(e => e !== offer)
      }
    },
    selectDNAMix(offer) {
      console.log('selectDNAMix')
      if (this.selections.dnaMix.indexOf(offer) === -1) {
        this.selections.dnaMix.push(offer)
      } else {
        this.selections.dnaMix = this.selections.dnaMix.filter(e => e !== offer)
      }
    },
    selectChannels() {
      console.log('selectChannels')
    },
    updateCart() {

    },
    toggleActive(offer) {
      if (typeof offer.isActive === 'undefined') {
        this.$set(offer, 'isActive', true)
        return;
      }
      offer.isActive = offer.isActive ? false : true;
      
    },
    checkForm() {
      console.log('checkForm');

      let errors = [];
      
      Object.keys(this.customer).map(key => {
        console.log(key)
      })
    }
  }
}
</script>
